import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { CountUp } from 'countup.js';
import { 
  faRocket, 
  faPiggyBank, 
  faAward, 
  faBriefcase, 
  faChartLine, 
  faGlobeEurope, 
  faChalkboardTeacher,
  faUserGraduate,
  faCheck,
  faCaretRight,
  faClipboardCheck,
  faUniversity,
  faSchool,
  faChartBar,     // Added for grading section
  faTasks,        // Added for initial assessment section
  faCalculator    // Added for mathematics section
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faRocket, 
  faPiggyBank, 
  faAward, 
  faBriefcase, 
  faChartLine, 
  faGlobeEurope,
  faChalkboardTeacher,
  faUserGraduate,
  faCheck,
  faCaretRight,
  faClipboardCheck,
  faUniversity,
  faSchool,
  faChartBar,     // Added
  faTasks,        // Added
  faCalculator    // Added
)
dom.watch()

document.addEventListener('DOMContentLoaded', function() {
    const subNav = document.getElementById('foundationSubNav');
    if (!subNav) return;

    const mainNav = document.querySelector('.navbar');
    const navLinks = subNav.getElementsByClassName('nav-link');
    const indicator = subNav.querySelector('.nav-indicator');
    const sections = document.querySelectorAll('section[id]');
    
    // Create a placeholder to prevent content jump
    const placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    subNav.parentNode.insertBefore(placeholder, subNav);
    
    // Initial position of indicator
    const activeLink = subNav.querySelector('.nav-link.active');
    if (activeLink) positionIndicator(activeLink);

    // Sticky behavior
    let isSticky = false;
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        const rect = subNav.getBoundingClientRect();
        const placeholderRect = placeholder.getBoundingClientRect();
        const shouldBeSticky = rect.top <= 0;
        
        if (shouldBeSticky !== isSticky) {
            isSticky = shouldBeSticky;
            
            if (isSticky) {
                placeholder.style.display = 'block';
                placeholder.style.height = rect.height + 'px';
                subNav.style.position = 'fixed';
                subNav.style.top = '0';
                subNav.style.left = rect.left + 'px';
                subNav.style.zIndex = '1029';
                subNav.style.boxShadow = '0 2px 4px rgba(0,0,0,0.1)';
                mainNav.classList.add('slide-up');
            }
        }

        // Check if we should unstick
        if (placeholderRect.top > 0) {
            isSticky = false;
            placeholder.style.display = 'none';
            subNav.style.position = '';
            subNav.style.top = '';
            subNav.style.left = '';
            subNav.style.zIndex = '';
            subNav.style.boxShadow = '';
            mainNav.classList.remove('slide-up');
        }

        // Handle scroll direction for main nav
        if (currentScroll < lastScroll && placeholderRect.top > 0) {
            mainNav.classList.remove('slide-up');
        }
        
        lastScroll = currentScroll;
        
        // Update active section while scrolling
        let currentSection = '';
        sections.forEach(section => {
            const sectionTop = section.offsetTop - 100;
            const sectionHeight = section.offsetHeight;
            if (currentScroll >= sectionTop && currentScroll < sectionTop + sectionHeight) {
                currentSection = section.getAttribute('id');
            }
        });
        
        Array.from(navLinks).forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href').substring(1) === currentSection) {
                link.classList.add('active');
                positionIndicator(link);
            }
        });
    });

    // Smooth scroll
    Array.from(navLinks).forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = link.getAttribute('href');
            const targetSection = document.querySelector(targetId);
            targetSection.scrollIntoView({ behavior: 'smooth' });
        });
    });

    // Position indicator function
    function positionIndicator(element) {
        indicator.style.width = `${element.offsetWidth}px`;
        indicator.style.left = `${element.offsetLeft}px`;
    }

    // Add CountUp initialization
    const options = {
        duration: 2.5,
        useEasing: true,
        useGrouping: false,
    };

    const counter1 = new CountUp('counter1', 100, options);
    const counter2 = new CountUp('counter2', 87, options);
    const counter3 = new CountUp('counter3', 76, options);

    // Function to check if element is in viewport
    const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    // Function to start animation when elements are visible
    const handleScroll = () => {
        const counter1Element = document.getElementById('counter1');
        if (counter1Element && isElementInViewport(counter1Element)) {
            counter1.start();
            counter2.start();
            counter3.start();
            // Remove scroll listener once animation has started
            window.removeEventListener('scroll', handleScroll);
        }
    };

    // Add scroll listener
    window.addEventListener('scroll', handleScroll);
    // Check initial state
    handleScroll();

    $('.nurazreen-vid').click(function () {
        $(this).empty()
        $(this).append('<stream src="e6978e789098e91a238813f237b4003c" controls autoplay></stream><script data-cfasync="false" defer type="text/javascript" src="https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=e6978e789098e91a238813f237b4003c"></script>')
      });
      $('.er-hao-vid').click(function () {
        $(this).empty()
        $(this).append('<stream src="322495beabfd3c576c8155f228b6466f" controls autoplay></stream><script data-cfasync="false" defer type="text/javascript" src="https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=322495beabfd3c576c8155f228b6466f"></script>')
      });
}); 